import { Locale } from "@/features/documents/types.ts";

// Форма ответа фиксирована: её же разбирает мобильное приложение.
export type Contacts = {
  phone: string;
  phoneDisplay: string;
  mobilePhone: string;
  email: string;
  whatsapp: string;
  whatsappDisplay: string;
  address: Record<string, string>;
};

export const EMPTY_CONTACTS: Contacts = {
  phone: "",
  phoneDisplay: "",
  mobilePhone: "",
  email: "",
  whatsapp: "",
  whatsappDisplay: "",
  address: {},
};

// Поля, у которых значение «для действия» отличается от «для показа»:
// по phone строится tel:, по whatsapp — ссылка wa.me.
export const CONTACT_FIELDS: {
  key: keyof Omit<Contacts, "address">;
  label: string;
  hint?: string;
  placeholder: string;
}[] = [
  {
    key: "phone",
    label: "Телефон (для звонка)",
    hint: "Уходит в tel:, только цифры и +",
    placeholder: "+7727123456",
  },
  {
    key: "phoneDisplay",
    label: "Телефон (как показывать)",
    placeholder: "+7 727 123-456",
  },
  {
    key: "mobilePhone",
    label: "Сотовый (как показывать)",
    placeholder: "+7 (777) 231-24-12",
  },
  {
    key: "email",
    label: "Email",
    placeholder: "admin@sapsano.kz",
  },
  {
    key: "whatsapp",
    label: "WhatsApp (для ссылки)",
    hint: "Уходит в wa.me, только цифры и +",
    placeholder: "+77772312412",
  },
  {
    key: "whatsappDisplay",
    label: "WhatsApp (как показывать)",
    placeholder: "+7 (777) 231-24-12",
  },
];

export type { Locale };
